var render, staticRenderFns
import script from "./associated_customer_one.vue?vue&type=script&lang=js"
export * from "./associated_customer_one.vue?vue&type=script&lang=js"
import style0 from "./associated_customer_one.vue?vue&type=style&index=0&id=60676ed0&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60676ed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60676ed0')) {
      api.createRecord('60676ed0', component.options)
    } else {
      api.reload('60676ed0', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/position_information/associated/associated_customer/associated_customer_one.vue"
export default component.exports